module.exports = __webpack_public_path__ + "static/media/corporate-services-img77.eafee419.jpg";